import { 
  Trophy, TrendingUp, Target, Star, Award,
  Zap, Heart, ThumbsUp, CheckCircle, Flag, Gift, Crown, Medal, Rocket,
  DollarSign, Users, Briefcase, Phone, Mail, Calendar, Clock, FileText,
  ShoppingCart, Home, Car, Plane, Coffee, Music, Camera, Smile, Sun,
  Moon, Cloud, Umbrella, Flame, Leaf, Mountain, Waves, Sparkles, Gem,
  Lightbulb, Bell, Bookmark, Building, Calculator, ChartBar, CircleDollarSign,
  Coins, CreditCard, Diamond, Euro, Fingerprint, Globe, Hammer, Handshake,
  Key, Layers, Link, Lock, Map, MessageCircle, Mic, Package, Palette,
  PenTool, Percent, PieChart, Plug, Power, Presentation, QrCode, Radio,
  Receipt, Repeat, Scale, Search, Send, Settings, Shield, Signal, Smartphone,
  Speaker, Tag, Terminal, Timer, Truck, Tv, Upload, Video, Wallet, Watch,
  Wifi, Wrench, XCircle, Activity, Anchor, Archive, AtSign, Banknote,
  BarChart3, Battery, BellRing, Binary, Bluetooth, Bomb, Bot, Box,
  Brain, Bug, Bus, Cake, CalendarCheck, CameraOff, Cast, ChartLine,
  ChartPie, Check, Cigarette, Clipboard, CloudRain, Code, Compass, Contact,
  Cpu, Database, Dice1, Disc, Download, Droplet, Ear, Edit, Eye, EyeOff,
  FastForward, Feather, File, Filter, Folder, Frown, Gamepad2, Gauge,
  Ghost, Glasses, GraduationCap, Grape, Grid, Hand, HardDrive, Headphones,
  Hexagon, History, Image, Inbox, Info, Keyboard, Laptop,
  LayoutGrid, LifeBuoy, List, ListChecks, Loader, LogIn, LogOut,
  Magnet, Maximize, Menu, MessageSquare, Minimize, Minus, Monitor, MoreHorizontal,
  MousePointer, Move, Navigation, Newspaper, Notebook, PaintBucket, Paperclip,
  Pause, PenSquare, PhoneCall, PhoneOff, Pin, Play, PlusCircle, Pocket,
  Podcast, Printer, Puzzle, RefreshCw, Rewind, RotateCw, Rss, Ruler, Save,
  Scissors, Server, Share, ShoppingBag, Shuffle, Sidebar, SkipBack, SkipForward,
  Sliders, Snowflake, Square, StepForward,
  Stethoscope, Sunrise, Sunset, Table,
  Tablet, Tent, Thermometer, ToggleLeft, ToggleRight, Trash,
  Trees, TrendingDown, Triangle, Type, Undo, Unlink, User,
  UserCheck, UserMinus, UserPlus, UserX, Vibrate, VolumeX, Volume2,
  Wand2, Wind, Wine, ZoomIn, ZoomOut, Siren, Rainbow, Pizza,
  PartyPopper, Milk, IceCreamCone, Croissant, Cherry, Apple, Armchair, Baby,
  Backpack, BadgeCheck, BadgeDollarSign, BadgePercent, Banana, Bath,
  BedDouble, Beer, Bike, Bird, Bone, Book, BookOpen, Boxes, Building2,
  Clapperboard, Construction, Cookie, CupSoda,
  Dna, Dog, Drama, Drumstick, Dumbbell, Factory, Fan, Fish, Flower,
  Footprints, Fuel, Drill, Guitar, HardHat,
  Heater, Highlighter, Hospital, Hotel, Hourglass, Joystick, Kanban,
  KeyRound, Lamp, Languages, Lasso, Laugh, Layout, LayoutDashboard, LayoutList,
  Library, Ligature, LineChart, ListMinus, ListOrdered, ListPlus,
  ListTree, Locate, LockOpen, MapPin, Martini,
  Megaphone, Meh, MemoryStick, Merge, MessageCirclePlus, Microscope, Microwave,
  Milestone, MilkOff, MonitorSmartphone, MoonStar, MoreVertical,
  MousePointer2, MoveHorizontal, MoveVertical, Music2, Music3, Music4, Network,
  Nfc, OctagonX, Option, Orbit, Outdent, PackageCheck, PackageMinus, PackageOpen,
  PackagePlus, PackageSearch, PackageX, PaintbrushVertical, Palmtree, PanelBottom,
  PanelLeft, PanelRight, PanelTop, Parentheses, ParkingCircle,
  type LucideIcon
} from "lucide-react";

export interface PerformanceMetric {
  id: string;
  name: string;
  description: string | null;
  points_value: number;
  is_active: boolean;
  icon: string | null;
  sort_order: number;
}

// Available icons for selection
export const AVAILABLE_ICONS: { name: string; icon: LucideIcon }[] = [
  // Achievements & Success
  { name: "trophy", icon: Trophy },
  { name: "award", icon: Award },
  { name: "medal", icon: Medal },
  { name: "crown", icon: Crown },
  { name: "star", icon: Star },
  { name: "sparkles", icon: Sparkles },
  { name: "gem", icon: Gem },
  { name: "diamond", icon: Diamond },
  { name: "graduation-cap", icon: GraduationCap },
  
  // Business & Sales
  { name: "trending-up", icon: TrendingUp },
  { name: "target", icon: Target },
  { name: "chart-bar", icon: ChartBar },
  { name: "chart-line", icon: ChartLine },
  { name: "chart-pie", icon: ChartPie },
  { name: "bar-chart", icon: BarChart3 },
  { name: "pie-chart", icon: PieChart },
  { name: "briefcase", icon: Briefcase },
  { name: "building", icon: Building },
  { name: "handshake", icon: Handshake },
  { name: "presentation", icon: Presentation },
  { name: "clipboard", icon: Clipboard },
  
  // Money & Finance
  { name: "dollar-sign", icon: DollarSign },
  { name: "euro", icon: Euro },
  { name: "coins", icon: Coins },
  { name: "banknote", icon: Banknote },
  { name: "wallet", icon: Wallet },
  { name: "credit-card", icon: CreditCard },
  { name: "circle-dollar", icon: CircleDollarSign },
  { name: "receipt", icon: Receipt },
  { name: "percent", icon: Percent },
  { name: "calculator", icon: Calculator },
  
  // Communication
  { name: "phone", icon: Phone },
  { name: "phone-call", icon: PhoneCall },
  { name: "mail", icon: Mail },
  { name: "message-circle", icon: MessageCircle },
  { name: "message-square", icon: MessageSquare },
  { name: "send", icon: Send },
  { name: "megaphone", icon: Megaphone },
  
  // People & Team
  { name: "users", icon: Users },
  { name: "user", icon: User },
  { name: "user-check", icon: UserCheck },
  { name: "user-plus", icon: UserPlus },
  { name: "contact", icon: Contact },
  
  // Time & Calendar
  { name: "calendar", icon: Calendar },
  { name: "calendar-check", icon: CalendarCheck },
  { name: "clock", icon: Clock },
  { name: "timer", icon: Timer },
  { name: "hourglass", icon: Hourglass },
  
  // Actions & Status
  { name: "check-circle", icon: CheckCircle },
  { name: "thumbs-up", icon: ThumbsUp },
  { name: "zap", icon: Zap },
  { name: "rocket", icon: Rocket },
  { name: "flag", icon: Flag },
  { name: "lightbulb", icon: Lightbulb },
  { name: "heart", icon: Heart },
  { name: "gift", icon: Gift },
  
  // Nature & Weather
  { name: "sun", icon: Sun },
  { name: "moon", icon: Moon },
  { name: "cloud", icon: Cloud },
  { name: "flame", icon: Flame },
  { name: "leaf", icon: Leaf },
  { name: "mountain", icon: Mountain },
  { name: "waves", icon: Waves },
  { name: "rainbow", icon: Rainbow },
  
  // Objects
  { name: "home", icon: Home },
  { name: "car", icon: Car },
  { name: "plane", icon: Plane },
  { name: "truck", icon: Truck },
  { name: "shopping-cart", icon: ShoppingCart },
  { name: "package", icon: Package },
  { name: "box", icon: Box },
  { name: "key", icon: Key },
  { name: "lock", icon: Lock },
  { name: "shield", icon: Shield },
  
  // Technology
  { name: "smartphone", icon: Smartphone },
  { name: "laptop", icon: Laptop },
  { name: "monitor", icon: Monitor },
  { name: "wifi", icon: Wifi },
  { name: "signal", icon: Signal },
  { name: "globe", icon: Globe },
  { name: "database", icon: Database },
  { name: "cpu", icon: Cpu },
  { name: "code", icon: Code },
  { name: "terminal", icon: Terminal },
  
  // Media
  { name: "camera", icon: Camera },
  { name: "video", icon: Video },
  { name: "music", icon: Music },
  { name: "mic", icon: Mic },
  { name: "headphones", icon: Headphones },
  { name: "tv", icon: Tv },
  { name: "radio", icon: Radio },
  
  // Food & Drink
  { name: "coffee", icon: Coffee },
  { name: "pizza", icon: Pizza },
  { name: "cake", icon: Cake },
  { name: "beer", icon: Beer },
  { name: "wine", icon: Wine },
  { name: "martini", icon: Martini },
  { name: "apple", icon: Apple },
  { name: "cherry", icon: Cherry },
  { name: "banana", icon: Banana },
  { name: "cookie", icon: Cookie },
  
  // Misc
  { name: "smile", icon: Smile },
  { name: "laugh", icon: Laugh },
  { name: "party", icon: PartyPopper },
  { name: "bell", icon: Bell },
  { name: "bookmark", icon: Bookmark },
  { name: "tag", icon: Tag },
  { name: "settings", icon: Settings },
  { name: "wrench", icon: Wrench },
  { name: "hammer", icon: Hammer },
  { name: "palette", icon: Palette },
  { name: "pen-tool", icon: PenTool },
  { name: "file-text", icon: FileText },
  { name: "folder", icon: Folder },
  { name: "archive", icon: Archive },
  { name: "map", icon: Map },
  { name: "compass", icon: Compass },
  { name: "layers", icon: Layers },
  { name: "grid", icon: Grid },
  { name: "activity", icon: Activity },
  { name: "gauge", icon: Gauge },
  { name: "scale", icon: Scale },
  { name: "brain", icon: Brain },
  { name: "bot", icon: Bot },
  { name: "wand", icon: Wand2 },
];

// Helper to get icon component by name
export const getIconByName = (name: string): LucideIcon => {
  const found = AVAILABLE_ICONS.find(i => i.name === name);
  return found?.icon || Trophy;
};